// src/components/Header.js
import React from "react";
import "../css/LandingPageNew.scss";
import { useNavigate } from 'react-router-dom';
import { HeroSectionImage } from "../../../assets";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { logEvent } from "../../../utils/Analytics";
const GetStarted = () => {
  const { user } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const handleGetStartedClick = () => {
    logEvent("Button", "Clicked Get Started", user ? user.role : "Guest");
  };

  const path = !user
    ? "/signup"
    : user?.role === "User"
    ? "/matchedHourlyProject/all"
    : "/employerApplication/Hourly";

  return (
    <section className="hero-section">
        <div className="content-wrapper">
          <div className="hero-content">
            <h1>Connecting Top Talent with Leading Companies</h1>
            <p className="subtitle">
              Efficiently bridging the gap between skilled professionals and businesses.
            </p>
            {/* <a href={!user ? "/signup" : (user?.role === "User" ? "/matchedHourlyProject/all" : "/employerApplication/Hourly")} className="get-started-btn" style={{textDecoration:"none"}} onClick={handleGetStartedClick}>Get started</a> */}
            {/* <a
  href={!user ? "/signup" : (user?.role === "User" ? "/matchedHourlyProject/all" : "/employerApplication/Hourly")}
  className="get-started-btn"
  style={{ textDecoration: "none" }}
  onClick={(e) => {
    e.preventDefault();
    const path = !user ? "/signup" : (user?.role === "User" ? "/matchedHourlyProject/all" : "/employerApplication/Hourly");
    
    handleGetStartedClick(); // Your analytics function
    
    // Use React Router navigation instead of direct history manipulation
    navigate(path);
  }}
>
  Get started
</a> */}
<Link
            to={path}
            className="get-started-btn"
            style={{ textDecoration: "none" }}
            onClick={handleGetStartedClick}
          >
            Get started
          </Link>
          </div>
          
          <div className="hero-illustration">
            <img src={HeroSectionImage} alt="Hero section Image" />
          </div>
        </div>
      </section>

  );
};

export default GetStarted;
